import { createContext, useState, useContext } from 'react';

type Modaltype = {
  isVisible: boolean;
  setisVisible: React.Dispatch<React.SetStateAction<boolean>>;
};
export const ModalContext = createContext<Modaltype | null>(null);
export const ModalContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isVisible, setisVisible] = useState<boolean>(false);
  return (
    <ModalContext.Provider value={{ isVisible, setisVisible }}>
      {children}
    </ModalContext.Provider>
  );
};

export function useNonnullFunction() {
  const context = useContext(ModalContext);
  if (context === null) {
    throw new Error('do not use this outside of context');
  }
  return context;
}
